(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["home-liquid-elements-machines"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.le-machine-showcase').forEach((section) => {
    const scroller = section.querySelector('[data-machine-scroller]');
    const previous = section.querySelector('[data-machine-previous]');
    const next = section.querySelector('[data-machine-next]');
    if (!scroller || !previous || !next) return;

    const updateControls = () => {
      const maximum = scroller.scrollWidth - scroller.clientWidth;
      previous.disabled = scroller.scrollLeft <= 2;
      next.disabled = scroller.scrollLeft >= maximum - 2;
    };
    const move = (direction) => {
      const card = scroller.querySelector('.le-machine-card');
      const gap = Number.parseFloat(window.getComputedStyle(scroller).columnGap) || 0;
      scroller.scrollBy({ left: direction * ((card?.getBoundingClientRect().width || scroller.clientWidth) + gap), behavior: 'smooth' });
    };

    previous.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    scroller.addEventListener('scroll', updateControls, { passive: true });
    window.addEventListener('resize', updateControls);
    updateControls();
  });

  } catch(e) { console.error(e); }
})();
})();
